import { render } from "./articleEditor.vue?vue&type=template&id=655a23e6"
import script from "./articleEditor.vue?vue&type=script&lang=js"
export * from "./articleEditor.vue?vue&type=script&lang=js"

import "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__